import { createStore } from "redux";
import { neuralActionsApp } from '../reducers';

const NeuralActionsApp = createStore(neuralActionsApp,    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export default NeuralActionsApp